import axios from "axios";

const gupshup = {
  sendGupshupWA: async (destination: string, params: any[]) => {
    const proxyUrl = 'https://groot.5cn.co.in/webhook/b7b1fb24-1b05-48a2-9267-4f0c06b8192d';

    const payload = {
      // destination,
      // params,
      // template: {
      //   id: process.env.REACT_APP_GUPSHUP_OTP_TEMPLATE_ID,
      //   params: params.map((param) => encodeURIComponent(param)),
      // },
      
      channel: "whatsapp",
      source: process.env.REACT_APP_GUPSHUP_SOURCE_NUMBER,
      destination,
      "src.name": process.env.REACT_APP_GUPSHUP_SOURCE_NAME,
      template: {
          id: process.env.REACT_APP_GUPSHUP_OTP_TEMPLATE_ID,
          params: params.map((param) => encodeURIComponent(param)),
        }
    };

    try {
      const response = await axios.post(proxyUrl, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error: any) {
      console.error(
        "Error sending message via Gupshup:",
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  },
};

export default gupshup;
